/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import './Facilities.scss'
import { SettingsManager } from '../../../../configuration/SettingsManager'
import { CommonUtils } from '../../../../utils/CommonUtils'
import { IHealthCareFacility } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface IFacilitiesProps {
	data: IHealthCareFacility[]
}

interface IFacilitiesState {
	collapse: number
}

export class FacilitiesComponent extends React.Component<IFacilitiesProps, IFacilitiesState> {
	private dateFormat = 'MM/DD/YYYY'

	render(): React.ReactNode {
		let count = 1
		const facilitiesData = this.props.data

		if (typeof facilitiesData !== 'undefined' && facilitiesData !== null && facilitiesData.length > 0) {
			for (let index = 0; index < facilitiesData.length; index++) {
				facilitiesData[index].startDate = new Date(facilitiesData[index].startDate)
				facilitiesData[index].endDate = new Date(facilitiesData[index].endDate)
			}
		}

		const rows = facilitiesData.length
		return facilitiesData
			.sort((o1, o2) => CommonUtils.compareProperty(o2.startDate, o1.startDate))
			.map((element, index) => {
				const classBorder = count++ === rows ? 'bottom-border-td' : ''
				if (element.serviceTypeCode === '42') {
					return (
						<tbody key={index}>
							<tr>
								<td>{element.typeDescription}</td>
								<td>{CommonUtils.DateRange(element.startDate, element.endDate)}</td>
								<td>
									DOEBA: <strong>{CommonUtils.getDate(element.doeba, this.dateFormat)}</strong>
								</td>
								<td>
									DOLBA: <strong>{CommonUtils.getDate(element.dolba, this.dateFormat)}</strong>
								</td>
							</tr>
							<tr>
								<td>&nbsp;</td>
								<td className="bottom-border-td">
									<strong>{element.contractor}</strong>
								</td>
								<td className="bottom-border-td">
									Number: <strong>{element.contractorNumber}</strong>
								</td>
								<td className="bottom-border-td">
									NPI: <strong>{element.providerNumber}</strong>
								</td>
							</tr>
							{element.message !== undefined && element.message !== '' && element.message !== null ? (
								<tr>
									<td className="bottom-border-td">Patient Status Code:</td>
									<td colSpan={3} className="bottom-border-td">
										<strong>{element.message}</strong>
									</td>
								</tr>
							) : (
								''
							)}
						</tbody>
					)
				} else if (new Date(element.createdDate) >= SettingsManager.HospiceEpisodeDisplayDate && element.serviceTypeCode === '45') {
					return (
						<tbody key={index}>
							<tr>
								<td>{element.typeDescription}:</td>
								<td>{CommonUtils.DateRange(element.startDate, element.endDate)}</td>
								<td>
									DOEBA: <strong>{CommonUtils.getDate(element.doeba, this.dateFormat)}</strong>
								</td>
								<td>
									Hospice Days: <strong>{element.hospiceDays}</strong>
								</td>
							</tr>
							<tr>
								<td>&nbsp;</td>
								<td className="bottom-border-td">
									NPI: <strong>{element.providerNumber}</strong>{' '}
								</td>
								<td className="bottom-border-td">
									DOLBA: <strong>{CommonUtils.getDate(element.dolba, this.dateFormat)}</strong>
								</td>
								<td className="bottom-border-td">{element.message}</td>
							</tr>
						</tbody>
					)
				} else {
					return (
						<tbody key={index}>
							<tr>
								<td>{element.typeDescription}:</td>
								<td className={classBorder}>{CommonUtils.DateRange(element.startDate, element.endDate)}</td>
								<td className={classBorder}>{element.message}</td>
								<td className={classBorder}>
									NPI: <strong>{element.providerNumber}</strong>{' '}
								</td>
							</tr>
						</tbody>
					)
				}
			})
	}
}
